export default {
  baseURL: 'https://invoices.pietroalberti.ch/api/v2'
}
